import React, { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import { MenuItem, Select, Popover, FormControlLabel, Checkbox, Avatar } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import high from "../../../../components/assets/high_priority.svg";
import low from "../../../../components/assets/low_priority.svg";
import normal from "../../../../components/assets/normal_priority.svg";
import { postRequest } from "../../../../components/axiosClient";
import {
  errorNotification,
  successNotification,
} from "../../../../components/toast-notification/common-toast";
import { CREATE_TASK } from "../../../../components/utils";
import CommonDatePicker from "../../../CommonDatePicker";
import { IoIosCheckmark } from "react-icons/io";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { priorityOptions } from "../../../../components/common/const";

const TaskInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px;
  min-height: auto;
  border-radius: 8px;
  background: white;
  margin-top: 15px;
  gap: .40rem;
  box-sizing: border-box !important;
  border: 1 solid white;

  &:hover {
    border-color: black;
  }

  .secondary-details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-size: 12px;
    font-weight: 400px;
    color: #7d7d7d;
  }
`;



const CustomStyledSelect = styled(Select)`
  &.MuiSelect-root {
    padding: 0 !important;
    color: #7d7d7d;
    border:"0.5px dotted #9885C2",
  }

  .MuiSelect-select {
    padding: 0;
    // padding-right: 24px !important;
    background-color: #9885C2
    color:"white"
    &:focus {
      background-color: white !important;
      background-color: #9885C2
    }
  }

  &:before,
  &:after {
    display: none;
  }

  &:hover:not(.Mui-disabled):before {
    border-bottom: none;
  }
`;
const StyledSelect = styled(Select)`
  &.MuiSelect-root {
    padding: 8px;
  }
  .MuiSelect-select {
    padding: 8px;
    color:"white"
    &:focus {
      background-color: white !important;
      background-color: #9885C2
    }
  }
  &:before,
  &:after {
    display: none;
  }
  &:hover:not(.Mui-disabled):before {
    border-bottom: none;
  }
`;

const customIcons = {
  Low: <img src={low} alt="Low" style={{ width: "14px", height: "14px" }} />,
  Medium: (
    <img src={normal} alt="Medium" style={{ width: "14px", height: "14px" }} />
  ),
  High: <img src={high} alt="High" style={{ width: "14px", height: "14px" }} />,
};

// const priorityOptionsList = ["Low", "Medium", "High"];

const AddTaskListRow = ({
  onCancel,
  projectId,
  getTasks,
  memberList,
  boardView,
  columnId,
}) => {
  const navigate = useNavigate();
  const formRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const priorityOption = priorityOptions?.map((props) => ({
    label: props,
    value: props,
    icon: customIcons[props],
  }));

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      title: "",
      due_date: null,
      assigned_to: null,
      priority: priorityOption[0].value,
      project_id: projectId,
      status_id: columnId,
      is_completed: false
    },
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isInsidePopover = !!document
        .querySelector(".MuiPopover-root")
        ?.contains(event.target);
      const isInsideDatePicker = !!document
        .querySelector(".MuiPickersPopper-root")
        ?.contains(event.target);

      if (
        formRef.current &&
        !formRef.current.contains(event.target) &&
        !isInsidePopover &&
        !isMenuOpen &&
        !isInsideDatePicker &&
        !isDatePickerOpen
      ) {
        reset();
        onCancel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onCancel, reset, isMenuOpen, isDatePickerOpen]);

  const onSubmit = async (data) => {
    try {
      const res = await postRequest(CREATE_TASK, data, navigate);
      if (res.type === 1) {
        if (res.response.data.success) {
          await getTasks();
          successNotification(res.response.data.message);
          reset();
          onCancel();
        } else {
          errorNotification(res.response.data.message);
        }
      }
      if (res.type === 2) {
        errorNotification(res.errormessage || res.errors);
      }
    } catch (error) {
      errorNotification(error.message);
    }
  };

  const handleSelectOpen = () => setIsMenuOpen(true);
  const handleSelectClose = () => setIsMenuOpen(false);
  const handleDatePickerOpen = () => setIsDatePickerOpen(true);
  const handleDatePickerClose = () => setIsDatePickerOpen(false);

  return (
    <div ref={formRef}>
      {boardView ? (
        <TaskInformation className="border-[#f1c1c1] opacity-100">
          {/* <div className=" d-flex gap-1 align-middle"> */}
          <div className="flex items-center gap-1 w-full m-0">
            <Controller
              name="is_completed"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <div
                      className={`rounded-full m-0 border flex items-center  cursor-pointer transition-all ${field.value ? "bg-green-600 text-white" : "bg-white text-black"
                        }`}
                      {...field} // Spread the field to bind the value and onChange
                      onClick={() => field.onChange(!field.value)} // Toggle the value
                    >
                      <IoIosCheckmark />
                    </div>
                  }
                  sx={{ margin: 0 }}
                />
              )}
            />
            <div className="w-full">
              <form onSubmit={handleSubmit(onSubmit)} className="flex-1">
                <Controller
                  name="title"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Enter task title"
                      className="w-full p-[6px] rounded-[8px] focus:outline-none focus:border-[#c4c4c4] hover:border-[#c4c4c4]"
                      autoFocus
                    />
                  )}
                />
              </form>
            </div>
            {/* </div> */}
          </div>

          <div className="flex justify-between items-center w-full text-sm text-[#7D7D7D]">
            <Controller
              name="priority"
              control={control}
              render={({ field }) => (
                <StyledSelect
                  {...field}
                  displayEmpty
                  variant="standard"
                  onOpen={handleSelectOpen}
                  onClose={handleSelectClose}
                  MenuProps={{
                    container: formRef.current,
                  }}
                >
                  {priorityOption.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      <div className="flex items-center">
                        <span className="mr-2">{option.icon}</span>
                        {option.label}
                      </div>
                    </MenuItem>
                  ))}
                </StyledSelect>
              )}
            />
          </div>
          <div className="flex justify-start gap-2 items-center align-middle w-full text-sm text-[#7D7D7D]">
            <Controller
              name="assigned_to"
              control={control}
              render={({ field }) => (
                <CustomStyledSelect
                  {...field}
                  displayEmpty
                  variant="standard"
                  onOpen={handleSelectOpen}
                  onClose={handleSelectClose}
                  IconComponent={null}
                  // renderValue={(selected) => {
                  //   if (!selected) {
                  //     return (
                  //       <span style={{ color: "#7d7d7d" }}>Assign to</span>
                  //     );
                  //   }
                  //   return memberList.find(
                  //     (member) => member.value === selected
                  //   )?.label;
                  // }}
                  // MenuProps={{
                  //   container: formRef.current,
                  // }}
                  renderValue={(selected) => {
                    if (!selected) {
                      return <span >
                        <AccountCircleIcon /></span>;
                      // return <span style={{ color: "#7d7d7d" }}>Assign to</span>;
                    }

                    const selectedMember = memberList.find((member) => member.value === selected);

                    if (selectedMember) {
                      const [firstName, lastName] = selectedMember.label.split(" ");
                      return `${firstName?.charAt(0).toUpperCase()}${lastName ? lastName.charAt(0).toUpperCase() : ''}`;
                    }

                    return "J";
                  }}
                  MenuProps={{
                    container: formRef.current,
                  }}
                  sx={{
                    border: '0.5px dotted #9885C2',
                    borderRadius: '50%',
                    backgroundColor: "#9885C2",
                    color: "white",
                    '& .MuiSelect-select.MuiInputBase-input.MuiInput-input': {
                      paddingRight: '0px',
                      minWidth: '16px',
                      width: "20px",
                      height: "20px",
                      border: "0.5px dotted #9885C2",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "11px",
                      backgroundColor: "#9885C2",
                      color: "white",
                      alignItems: "center"
                    },
                  }}
                >
                  {memberList.map((option) => (
                    <MenuItem
                      key={option.value || "none"}
                      value={option.value || null}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </CustomStyledSelect>
              )}
            />
            <Controller
              name="due_date"
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange } }) => (
                <CommonDatePicker
                  value={value}
                  format="dd-MMM"
                  onChange={(newValue, formattedDate) => {
                    onChange(formattedDate);
                    handleDatePickerClose();
                  }}
                  onOpen={handleDatePickerOpen}
                  onClose={handleDatePickerClose}
                  className="common-date-picker w-36"
                  PopperProps={{
                    container: formRef.current,
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      border: "none",
                      paddingRight: "0px",
                    },
                    "& .MuiInputBase-input": {
                      fontSize: "13px",
                      width: "100px",
                    },
                    "& .MuiButtonBase-root": {
                      marginRight: "-17px",
                    },
                  }}
                />
              )}
            />
          </div>

          <div className="flex gap-3">
            <button
              type="submit"
              onClick={handleSubmit(onSubmit)}
              className="px-3 py-1.5 text-sm font-medium text-white bg-[#267072] rounded hover:bg-[#267072] transition-colors"
            >
              Add
            </button>
            {/* <button
              onClick={() => {
                reset();
                onCancel();
              }}
              className="px-3 py-1.5 text-sm font-medium text-gray-600 hover:text-gray-800 bg-[#a2a5aa] hover:bg-[#a2a5aa] transition-colors text-white rounded"
            >
              Cancel
            </button> */}
          </div>
        </TaskInformation>
      ) : (
        <div className="grid grid-cols-6 px-2 py-2.5 bg-white border-b border-[#EFEFEF] mt-1">
          <div className="col-span-3 flex items-center gap-2 w-full pr-4">
            <form onSubmit={handleSubmit(onSubmit)} className="flex-1">
              <Controller
                name="title"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <input
                    {...field}
                    type="text"
                    placeholder="Enter task title"
                    className="w-[95%] p-[8px] border rounded-[8px] focus:outline-none focus:border-[#c4c4c4] hover:border-[#c4c4c4]"
                    autoFocus
                  />
                )}
              />
            </form>
          </div>

          <div className="col-span-1 pr-4">
            <div className="w-90">
              <Controller
                name="due_date"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <CommonDatePicker
                    value={value}
                    onChange={(newValue, formattedDate) => {
                      onChange(formattedDate);
                      handleDatePickerClose();
                    }}
                    onOpen={handleDatePickerOpen}
                    onClose={handleDatePickerClose}
                    label="Due Date"
                    className="common-date-picker"
                    PopperProps={{
                      container: formRef.current,
                    }}
                  />
                )}
              />
            </div>
          </div>

          <div className="col-span-1 pr-4">
            <Controller
              name="assigned_to"
              control={control}
              render={({ field }) => (
                <StyledSelect
                  {...field}
                  className="text-capitalize lg:w-36 2xl:w-44"
                  displayEmpty
                  onOpen={handleSelectOpen}
                  onClose={handleSelectClose}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <span style={{ color: "#7d7d7d" }}>Assign to</span>
                      );
                    }
                    return memberList.find(
                      (member) => member.value === selected
                    )?.label;
                  }}
                  MenuProps={{
                    container: formRef.current,
                  }}
                >
                  {memberList.map((option) => (
                    <MenuItem
                      key={option.value || "none"}
                      value={option.value || null}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </StyledSelect>
              )}
            />
          </div>

          <div className="col-span-1 pr-4">
            <Controller
              name="priority"
              control={control}
              render={({ field }) => (
                <StyledSelect
                  {...field}
                  className="text-capitalize w-44"
                  displayEmpty
                  onOpen={handleSelectOpen}
                  onClose={handleSelectClose}
                  MenuProps={{
                    container: formRef.current,
                  }}
                >
                  {priorityOption.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      <div className="flex items-center">
                        <span className="mr-2">{option.icon}</span>
                        {option.label}
                      </div>
                    </MenuItem>
                  ))}
                </StyledSelect>
              )}
            />

          </div>

          <div className="flex gap-3 mt-2">
            <button
              type="submit"
              onClick={handleSubmit(onSubmit)}
              className="px-3 py-1.5 text-sm font-medium text-white bg-[#267072] rounded hover:bg-[#267072] transition-colors"
            >
              Add
            </button>
            {/* <button
              onClick={() => {
                reset();
                onCancel();
              }}
              className="px-3 py-1.5 text-sm font-medium text-gray-600 hover:text-gray-800 bg-[#a2a5aa] hover:bg-[#a2a5aa] transition-colors text-white rounded"
            >
              Cancel
            </button> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default AddTaskListRow;
